/* istanbul ignore file */
// eslint-disable-next-line nebula-rules/check-exist-test-file
import { v4 as uuidv4 } from 'uuid';

export const generateUUID = () => uuidv4();
